// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_gj-3";
export var flatBottomCorners = "_gj-5";
export var productImage = "_gj-0";
export var quantityContainer = "_gj-2";
export var quantityHeader = "_gj-6";
export var tooltip = "_gj-1";
export var wrapAndEllipsesOverflow = "_gj-4";